import { ReactComponent as GCPIcon } from '@comet/assets/svg/gcp.svg';
import { ReactComponent as AWSIcon } from '@comet/assets/svg/aws.svg';
import { ReactComponent as AzureIcon } from '@comet/assets/svg/azure.svg';

export const CloudProviders = {
  GCP: <GCPIcon />,
  AWS: <AWSIcon />,
  AZURE: <AzureIcon />,
};
